<template>
    <a-row type="flex" justify="space-between" class="individual_header_container">
      <a-col>
        <img src="../../assets/icons/coolicon.svg" alt="選單" @click="showDrawer">
        <a-drawer
          placement="left"
          :closable="false"
          :visible="visible"
          @close="onClose"
        >
          <div align="end"> 
            <img src="../../assets/icons/close.svg" alt="選單" @click="onClose">
          </div>
          <ul class="menu_container">
            <router-link :to="`/individual/monitor?data=${deviceUid}`">
              <li @click="focusItem('map')" :class="mapItemColor">
                <div class="icon_container">
                  <img v-if="isMapSelected" src="../../assets/icons/menu_map_green_icon.svg" alt="監控地圖">
                  <img v-else src="../../assets/icons/menu_map_icon.svg" alt="監控地圖">
                </div>
                監控地圖
              </li>
            </router-link>
            <router-link :to="`/individual/schedule?data=${deviceUid}`">
              <li @click="focusItem('schedule')" :class="scheduleItemColor">
                <div class="icon_container">
                  <img v-if="isScheduleSelected" src="../../assets/icons/menu_schedule_green_icon.svg" alt="行程列表">
                  <img v-else src="../../assets/icons/menu_schedule_icon.svg" alt="行程列表">
                </div>
                行程列表
              </li>
            </router-link> 

            <router-link :to="`/individual/drivingReport?data=${deviceUid}`">
              <li @click="focusItem('drivingReport')" :class="drivingReportItemColor">
                <div class="icon_container">
                  <img v-if="isDrivingReportSelected" src="../../assets/icons/menu_driving_report_green.svg" alt="行駛報告">
                  <img v-else src="../../assets/icons/menu_driving_report.png" alt="行駛報告">
                </div>
                行駛報告
              </li>
            </router-link> 

            <router-link :to="`/individual/deviceInfo?data=${deviceUid}`">
              <li @click="focusItem('device')" :class="deviceItemColor">
                <div class="icon_container">
                  <img v-if="isDeviceSelected" src="../../assets/icons/menu_device_green_icon.svg" alt="裝置資訊">
                  <img v-else src="../../assets/icons/menu_device_icon.svg" alt="裝置資訊">
                </div>
                裝置資訊
              </li>
            </router-link>
            <li @click="focusItem('line')" :class="lineItemColor">
            <div class="icon_container">
              <img v-if="isLine" src="../../assets/icons/menu_line@_green_icon.svg" alt="加入LINE官方客服">
              <img v-else src="../../assets/icons/menu_line@_icon.svg" alt="加入LINE官方客服">
            </div>
              加入LINE官方客服
            </li>
          </ul>
        </a-drawer>
      </a-col>
      <a-col>
        <img class="logo" src="../../assets/icons/hino.svg" alt="HINO車隊">
      </a-col>
    </a-row>
</template>

<script>
  export default {
    name: 'IndividualInfoHeader',
    data() {
        return {
          visible: false,
          isMapSelected: this.$route.path === '/individual/monitor',
          isScheduleSelected: this.$route.path.indexOf('schedule') !== -1,
          isDeviceSelected: this.$route.path === '/individual/deviceInfo',
          isDrivingReportSelected: this.$route.path === '/individual/drivingReport',
          isLine: false,
          linkAddress: 'https://line.me/R/ti/p/@099wkacy',
          deviceUid: this.$route.query.data || '',
        };
    },
    mounted() {
      this.deviceUid = this.$route.query.data;
    },
    methods: {
      showDrawer() {
        this.visible = true;
      },
      onClose() {
        this.visible = false;
      },
      focusItem(item) {
        console.log(item);
        switch (item) {
          default:
          case 'map':
            this.isMapSelected = true;
            this.isScheduleSelected = false;
            this.isDeviceSelected = false;
            this.isDrivingReportSelected = false;
            break;
          case 'schedule':
            this.isMapSelected = false;
            this.isScheduleSelected = true;
            this.isDeviceSelected = false;       
            this.isDrivingReportSelected = false;
            break;
          case 'drivingReport':
            console.log('drivingReport');
            this.isMapSelected = false;
            this.isScheduleSelected = false;
            this.isDeviceSelected = false;
            this.isDrivingReportSelected = true;
            break;  
          case 'device':
            this.isMapSelected = false;
            this.isScheduleSelected = false;
            this.isDeviceSelected = true;
            this.isDrivingReportSelected = false;
            break;
          case 'line':
            this.isMapSelected = false;
            this.isScheduleSelected = false;
            this.isDeviceSelected = false;
            this.isDrivingReportSelected = false;
            this.isLine = true;
            window.open(this.linkAddress, '_blank');
            break;

        }
        this.onClose();
      },
    },
    computed: {
      mapItemColor() {
        return this.isMapSelected ? 'focus_green' : '';
      },
      scheduleItemColor() {
        return this.isScheduleSelected ? 'focus_green' : '';
      },
      deviceItemColor() {
        return this.isDeviceSelected ? 'focus_green' : '';
      },
      drivingReportItemColor() {
        return this.isDrivingReportSelected ? 'focus_green' : '';
      },
      lineItemColor() {
        return this.isLine ? 'focus_green' : '';
      },
    },
  }
</script>

<style scoped lang="scss">
  .individual_header_container {
    padding: 13px 14px;
    position: fixed;
    width: 100%;
    background-color: white;
    z-index: 10;
    height: 53px;
  }

  .menu_container {
    list-style: none;
    margin: 18px 0 0 0;
    padding: 0;
    li {
      display: flex;
      padding: 12px 13px;
      margin-bottom: 12px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #343741;
      .icon_container {
        width: 15%;
        img {
          margin-right: 14px;
        }
      }
    }
    li.focus_green {
      background-color: #EAF6C9;
      color: #638D0A;
    }
  }

  .logo {
    margin-top: -5px;
  }

</style>